import "../App.css";

function Skills() {
  return (
    <section id="skills" className="Skills-section">
      <h2 className="Skills-title">Skills</h2>
      <div className="Skills-container">
        <p className="Skills-item">
          <strong>Full-Stack:</strong> HTML/CSS, React, React Native, Node.js, Python, C/C++, Java, Javascript, SQL/PostgreSQL, Tailwind CSS
        </p>
        <p className="Skills-item">
          <strong>Tools:</strong> Git, Canva, Figma, Notion, Jira, Linear, VSCode, Cursor, Microsoft Office, Claude, OpenAI
        </p>
      </div>
    </section>
  );
}

export default Skills;